module.exports = __webpack_public_path__ + "static/media/18.fb0e1a44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/18.jpg
// module id = 588
// module chunks = 0